module.exports = __webpack_public_path__ + "static/media/13.115cdd15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/13.svg
// module id = 140
// module chunks = 0